<template>
  <div class="mb-3 mt-3">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('colony.form.not_found') }}</p>
          </b-card>
        </b-col>
      </b-row>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ data.title || "\u00a0" }}</h1>
      <b-row class="mb-5">
        <b-col class="col-12">
<!--          <b-form-select :class="{ 'with-placeholder': !form.reason }" v-model="form.reason" required :state="$v.form.reason.$dirty ? !$v.form.reason.$error : null" @blur="$v.form.reason.$touch">-->
          <b-form-select :class="{ 'with-placeholder': !form.reason }" v-model="form.reason">
<!--            <option :value="null" disabled>{{ $t('unite_colonies_or_remove_queen3.reason.label') }}</option>-->
            <option :value="null" >{{ $t('unite_colonies_or_remove_queen3.reason.label') }}</option>
            <option v-for="(text, value) in $t('unite_colonies_or_remove_queen3.reason.options')" :value="value" :key="value">{{ text }}</option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('unite_colonies_or_remove_queen3.cancel')" :to="'/colony/' + colony + '/' + data.apiary">
            {{ $t('unite_colonies_or_remove_queen3.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6">
          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen3.delete_colony')" @click.prevent="clickDelete">
            {{ $t('unite_colonies_or_remove_queen3.delete_colony') }}
          </b-link>
        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col class="col-12">-->
<!--          <b-link class="bg-primary text-light form-control text-center" :title="$t('unite_colonies_or_remove_queen3.unite_colonies')" @click="checkNetworkColonyUnite">-->
<!--            {{ $t('unite_colonies_or_remove_queen3.unite_colonies') }}-->
<!--          </b-link>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-modal :id="'confirmColonyDelete'" centered hide-header-close @ok="doDelete" class="delete-container">
        <template slot="modal-title">
          {{ $t('colonies.confirm_delete.title') }}
        </template>
        {{ $t('colonies.confirm_delete.text') }}
        <template slot="modal-footer" slot-scope="{ ok, cancel }">
          <b-button size="lg" class="ml-auto" @click="cancel()">
            {{ $t('colonies.confirm_delete.no') }}
          </b-button>
          <b-button size="lg" class="mr-auto" @click="ok()">
            {{ $t('colonies.confirm_delete.yes') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="'offLineModalColonyDelete'" centered hide-header-close @ok="hideModal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
export default {
  name: 'UniteColoniesOrRemoveQueen3',
  props: ['queen', 'colony'],
  data () {
    return {
      showError: false,
      loaded: false,
      loading: false,
      data: {
        title: null
      },
      form: {
        reason: null
      }
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalColonyDelete')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalColonyDelete')
    },
    checkNetworkColonyUnite () {
      if (navigator.onLine) {
        this.$router.replace('/unite-colonies/' + this.colony)
      } else {
        this.showOffLineModal()
      }
    },
    showModal () {
      this.$bvModal.show('confirmColonyDelete')
    },
    clickDelete () {
      if (navigator.onLine) {
        this.showModal()
      } else {
        this.showOffLineModal()
      }
    },
    async doDelete () {
      if (navigator.onLine) {
        // this.$v.form.$touch()
        // if (!this.$v.$error) {
        this.loading = true
        let result
        try {
          const token = await this.$api.user.getToken()
          result = this.$api.colonies.deleteItem({ id: this.colony, token })
          this.loading = false
        } catch (e) { // network error etc.
          if (e.response && e.response.status === 403) {
            this.loading = false
            this.$router.replace('/login')
          }

          result = false
        }
        if (result) {
          this.$router.replace('/apiary/' + this.data.apiary)
        }
        return result
        // }
      } else {
        this.showOffLineModal()
      }
    }
  },
  // validations: {
  //   form: {
  //     reason: {
  //       required
  //     }
  //   }
  // },
  async mounted () {
    if (this.colony) {
      try {
        this.data = await this.$api.colonies.getOne(this.colony)
        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style scoped>
  .container {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
